//import React from 'react';

import {
  Section,
  SectionText,
  SectionTitle,
  SectionAccent,
} from '../Section/Section.styles';
import Button from '../Button/Button';
import { HeroContainer, LeftSection } from '../Hero/HeroStyles';

import BgAnimation from '../BackgroundAnimation/BackgroundAnimation';

const Hero = () => (
  <HeroContainer>
    <Section grid hero>
      {/* <HeroContent> */}
      {/* <Section> */}
      <LeftSection>
        <SectionTitle>
          Sam Miller, <SectionAccent>Developer.</SectionAccent>
        </SectionTitle>
        <br />
        <SectionText>
          I'm a software developer with experience in responsive front end
          development with React, build &amp; test automation with CI/CD, and
          lower-level development in C and C++ as well. I enjoy problem-solving
          and am passionate about developing great software!
        </SectionText>
        {/* <Button onClick={() => (window.location = 'https://google.com')}>
          Contact
        </Button> */}
      </LeftSection>
      {/* </Section> */}
      {/* </HeroContent> */}
      <BgAnimation />
    </Section>
  </HeroContainer>
);

export default Hero;
